import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, apiError } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=guest, obj=user
  const [authOpen, setAuthOpen] = useState(false);
  const [authMode, setAuthMode] = useState("login");
  const [presetRole, setPresetRole] = useState("buyer");

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem("agoo_token");
    if (!token) { setUser(null); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("agoo_token");
      setUser(null);
    }
  }, []);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("agoo_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("agoo_token", data.token);
    setUser(data.user);
    return data.user;
  };

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const googleLogin = async (credential) => {
    const { data } = await api.post("/auth/google", { credential });
    localStorage.setItem("agoo_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("agoo_token");
    setUser(null);
  };

  const openAuth = (mode = "login", role = "buyer") => { setAuthMode(mode); setPresetRole(role); setAuthOpen(true); };

  const toggleWishlist = async (pid) => {
    const { data } = await api.post(`/wishlist/${pid}`);
    setUser((u) => (u ? { ...u, wishlist: data.wishlist } : u));
    return data.wishlist;
  };
  const isWished = (pid) => (user?.wishlist || []).includes(pid);

  return (
    <AuthContext.Provider value={{ user, login, register, googleLogin, logout, refreshUser: loadMe, toggleWishlist, isWished, authOpen, setAuthOpen, authMode, setAuthMode, openAuth, presetRole, apiError }}>
      {children}
    </AuthContext.Provider>
  );
}
